// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__b8zDJ","question":"styles_question__2NV3q","description":"styles_description__cYPGK"};